import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ArrowUpCircle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <title>Positive Indicator</title>
      <path
        d="M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20Z"
        fill={color}
        fillOpacity="0.1"
      />
      <path
        d="M13.531 8.97112L10.531 5.97112C10.3899 5.83164 10.1995 5.75342 10.001 5.75342C9.80261 5.75342 9.61218 5.83164 9.47104 5.97112L6.47104 8.97112C6.18104 9.26112 6.18104 9.74112 6.47104 10.0311C6.76104 10.3211 7.24104 10.3211 7.53104 10.0311L9.25104 8.31112V13.5011C9.25104 13.9111 9.59104 14.2511 10.001 14.2511C10.411 14.2511 10.751 13.9111 10.751 13.5011V8.31112L12.471 10.0311C12.621 10.1811 12.811 10.2511 13.001 10.2511C13.191 10.2511 13.381 10.1811 13.531 10.0311C13.821 9.74112 13.821 9.26112 13.531 8.97112Z"
        fill={color}
      />
    </svg>
  )
);

export default ArrowUpCircle;
